import type { ChangeEvent } from "react";

export const Checkbox = ({
  label,
  isChecked,
  onChange,
  dataTestId
}: {
  label?: string;
  isChecked: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  dataTestId?: string;
}) => {
  return (
    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        className="accent-primary w-[1.25rem] h-[1.25rem] cursor-pointer"
        checked={isChecked}
        onChange={onChange}
        data-testid={dataTestId ?? "checkbox-input"}
      />
      {label ? <p>{label}</p> : null}
    </div>
  );
};
